










import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { dayjs, DTW_FORMAT_JA } from '../../../src_server/common/momentExtends';
import LessonStateCard from './LessonStateCard.vue';
import TransferDialog from '../components/TransferDialog.vue';

@Component({ components: { CommonDialog, LessonStateCard, TransferDialog } })
export default class LessonStateDialog extends Vue {
  private dto: LessonDTO = new LessonDTO();
  private start_dt = '';
  private nickname = '';

  /**
   * ダイアログを開く
   */
  public async show(dto: LessonDTO) {
    this.dto = dto;
    this.start_dt = dayjs(this.dto.lessons.start_dt).format(DTW_FORMAT_JA);
    this.nickname = this.dto.student?.nickname || '';

    await (this.$refs['lesson_state_dialog'] as CommonDialog).show();
  }

  /**
   * 振替処理
   */
  async change(row: LessonDTO) {
    const dialog: TransferDialog = this.$refs['dialog'] as TransferDialog;
    const dt = row.lessons?.start_dt || new Date();
    dialog.show(dt, row);
  }

  /**
   * ダイアログを閉じる
   */
  public close() {
    (this.$refs['lesson_state_dialog'] as CommonDialog).hide();
  }
}
